const firebaseConfig = {
  apiKey: "AIzaSyAwc0faixO38Koriv_4T8BMmVt1F_GXDQM",
  authDomain: "creative-own-agency.firebaseapp.com",
  databaseURL: "https://creative-own-agency.firebaseio.com",
  projectId: "creative-own-agency",
  storageBucket: "creative-own-agency.appspot.com",
  messagingSenderId: "553019288323",
  appId: "1:553019288323:web:db0f5cf45da78e44c45736",
};
export default firebaseConfig;
